import React from 'react';
import T from './EditableText';

/**
 * Nummerierter Ablauf in Spalten (`.hx-steps`). Steht am Anfang eines Textes
 * ein fetter Satz („**Anruf.** …"), wird er zur Überschrift des Schritts.
 */
const StepList: React.FC<{ keys: string[] }> = ({ keys }) => (
  <ol className={`hx-steps__list hx-steps__list--text hx-steps__list--n${keys.length}`}>
    {keys.map((key, index) => (
      <li key={key}>
        <span className="hx-steps__num">{index + 1}</span>
        <p>
          <T k={key} />
        </p>
      </li>
    ))}
  </ol>
);

export default StepList;
